import React, { Component } from 'react'
import { injectIntl } from 'react-intl'

import * as formatters from '../../../common/formatters'
import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS } from '../permissions'

class DocumentTypesListRow extends Component {
    handleClick = e => {
        e && e.preventDefault()
        e && e.stopPropagation()

        this.props.onClick(this.props.data.id)
    }

    handleDelete = e => {
        e && e.preventDefault()
        e && e.stopPropagation()

        this.props.onDelete(this.props.data.id)
    }

    render = () => (
        <tr onClick={this.handleClick} className="row-selectable">
            <PermissionsCheck hasAny={[PERMS.UPDATE, PERMS.DELETE]}>
                <td className="w-60 table-buttons">
                    <PermissionsCheck has={[PERMS.UPDATE]}>
                        <button className="far fa-pencil text-gray m-r-xxs" />
                    </PermissionsCheck>
                    <PermissionsCheck has={[PERMS.DELETE]}>
                        <button onClick={this.handleDelete} className="far fa-trash text-gray" />
                    </PermissionsCheck>
                </td>
            </PermissionsCheck>
            <td className="w-100">{this.props.data.code}</td>
            <td className="w-max wm-300">{this.props.data.name}</td>
            <td className="w-120 text-right">
                {this.props.data.default_validity
                    ? `${this.props.data.default_validity} ${this.props.intl.formatMessage({ id: 'fields.monthsAbbr' })}`
                    : null}
            </td>
            <td className="w-100 text-center">{formatters.boolFormatter(this.props.data.is_for_drivers)}</td>
            <td className="w-100 text-center">{formatters.boolFormatter(this.props.data.is_for_vehicles)}</td>
            <td className="w-100 text-center">{formatters.boolFormatter(this.props.data.is_for_trailers)}</td>
            <td className="w-140 text-center">
                {formatters.boolFormatter(this.props.data.notify)}
                {this.props.data.notify ? <span> ({this.props.data.notify_days})</span> : null}
            </td>
            <td className="w-140 text-center">
                {formatters.boolFormatter(this.props.data.notify_in_board)}
                {this.props.data.notify_in_board ? <span> ({this.props.data.notify_in_board_days})</span> : null}
            </td>
        </tr>
    )
}

export default injectIntl(DocumentTypesListRow)
